import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GiFarmer, GiRemedy } from 'react-icons/gi';
import { FaFileContract, FaMapMarkedAlt } from 'react-icons/fa';
import '../styles/global.css';
import '../styles/pages/Home.css';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primeicons/primeicons.css';
import { MdAgriculture, MdMap } from 'react-icons/md';
import * as L from 'leaflet'
import 'leaflet-side-by-side'
import * as mapas from '../utils/mapas';
import { Dock } from 'primereact/dock';
import { MenuItem } from 'primereact/menuitem';
import { ReactComponent as OutIcon } from '../images/out.svg';
import { ReactComponent as AprovarIcon } from '../images/positive.svg';
import { ReactComponent as ReportIcon } from '../images/files-archive-svgrepo-com.svg';
import { ReactComponent as EditIcon } from '../images/pencil-svgrepo-com (1).svg';
import { ReactComponent as AppsIcon } from '../images/tablet-svgrepo-com (1).svg';
import { ReactComponent as ListIcon } from '../images/book-library-svgrepo-com.svg';
import { Messages } from 'primereact/messages';
import API from '../api/API';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Tooltip } from 'primereact/tooltip';
import CadastroPessoa from './dialogs/CadastroPessoa';
import { TabPanel, TabView } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import * as messages from '../utils/messages';
import CustomToolbar from './components/CustomToolbar';
import { DialogAprovacao } from './dialogs/Aprovacao';
import { DialogAntecipacoes } from './dialogs/Antecipacoes';
import CadastroImovel from './dialogs/CadastroImovel';
import DialogSearch from './dialogs/Search';
import Aplicativos from './Aplicativos';
import { ArrendamentoType, GroupType, ImovelType, newImovel, newPessoa, PermissionType, PessoaType, PropriedadeSearchType, SafraType, STATUS } from '../db/Orm';
import CadastroPlantio, { CadastroPlantioConfig } from './dialogs/CadastroPlantio';
import CadastroControles from './dialogs/CadastroControles';
import CadastroArrendamento from './dialogs/CadastroArrendamento';
import PropertySummaryWidget from './components/PropertySummaryWidget';
import { WeatherForecastWidget } from './components/WeatherForecastWidget';
import axios from 'axios';
import { HiDocumentReport } from "react-icons/hi";
import { BlockUI } from 'primereact/blockui';
import { ProgressSpinner } from 'primereact/progressspinner';
import TabPermissoes from './components/Permissoes';
import TabUsuarioPermissoes from './components/TabUsuarioPermissoes';
import ResponsavelTecnico from './dialogs/ResponsavelTecnico';
import { PiFarmFill, PiIdentificationBadgeFill } from 'react-icons/pi';
import Auth from '../auth/Authenticator';

const MENU_PERMISSOES = {
    Pesquisa: 'monitorabahia.pesquisa_arrendamentos,monitorabahia.pesquisa_municipio,monitorabahia.pesquisa_pessoas,monitorabahia.pesquisa_propriedades,monitorabahia.pesquisa_requerimentos',
    Aplicativos: 'monitorabahia.aplicativo_vaziosanitario,monitorabahia.aplicativo_coberturavegetal1,monitorabahia.aplicativo_coberturavegetal2,monitorabahia.aplicativo_coberturavegetalcar',
    Aprovar: 'monitorabahia.aprovacao_pessoas,monitorabahia.aprovacao_propriedades,monitorabahia.aprovacao_requerimentos,monitorabahia.aprovacao_planos,monitorabahia.aprovacao_arrendametos',
    Relatorio: 'monitorabahia.relatorio_cad_proprietarios,monitorabahia.relatorio_cad_propriedades,monitorabahia.relatorio_cad_lotes,monitorabahia.relatorio_pol_propriedades,monitorabahia.relatorio_pol_lotes,monitorabahia.relatorio_pla_usuarios',
    Cadastro: 'monitorabahia.cadastrar_pessoa,monitorabahia.cadastrar_imovel,monitorabahia.cadastrar_plantio,monitorabahia.cadastrar_controles,monitorabahia.cadastrar_arrendamentos,auth.view_permission',
    Relatorio_Cadastros: 'monitorabahia.relatorio_cad_proprietarios,monitorabahia.relatorio_cad_propriedades,monitorabahia.relatorio_cad_lotes',
    Relatorio_Poligonos: 'monitorabahia.relatorio_pol_propriedades,monitorabahia.relatorio_pol_lotes',
    Relatorio_Plataforma: 'monitorabahia.relatorio_pla_usuarios',
}
enum MENU_ITEMS { Pesquisa, Aprovar, Relatorio, Cadastro }

function Home() {
    const auth = Auth.useAuth();
    const navigate = useNavigate();
    //Da para usar tambem o https://openlayers.org/ ao inves de https://leafletjs.com/
    const mapRef = useRef<any>(null);
    const msgs = useRef<any>(null);
    const toastBC = useRef<Toast>(null);
    const toastCadastrar = useRef<Toast>(null);
    const [pessoas, setPessoas] = useState<Array<PessoaType>>([])
    const [propriedades, setPropriedades] = useState<ImovelType[]|undefined>(undefined)
    const [propriedadesSearch, setPropriedadesSearch] = useState<PropriedadeSearchType[]>([])
    const [municipios, setMunicipios] = useState<Array<any>>([])
    const [permissions, setPermissions] = useState<PermissionType[]>([])
    const [planos, setPlanos] = useState<Array<any>>([]);
    const [pessoa, setPessoa] = useState<PessoaType>(newPessoa)
    const [safras, setSafras] = useState<SafraType[]>([])
    const [loading, setLoading] = useState(false)
    const error = () => messages.errorMessage(toastBC.current)
    const [activeIndex, setActiveIndex] = useState(0)
    const [arrendamentos, setArrendamentos] = useState<Array<ArrendamentoType>>([])
    const [grupos, setGrupos] = useState<GroupType[]>([])
    const [menuLabels, setMenuLabels] = useState<string[]>([])
    const [lat, setLat] = useState<number>(-12.9716);
    const [lon, setLon] = useState<number>(-38.5014);
    const [abaSearch, setAbaSearch] = useState<number|undefined>()
    const [nomePropriedadeSearchFilter, setNomePropriedadeSearchFilter] = useState<string|undefined>()
    const updateMenuLabels = () => {
        const labels: string[] = []
        labels[MENU_ITEMS.Pesquisa] = ((auth.hasPermission('monitorabahia.pesquisa_municipio') ? ' - Municípios\n' : '') +
            (auth.hasPermission('monitorabahia.pesquisa_pessoas') ? ' - Pessoas\n' : '') +
            (auth.hasPermission('monitorabahia.pesquisa_propriedades') ? ' - Propriedades\n' : '') +
            (auth.hasPermission('monitorabahia.pesquisa_arrendamentos') ? ' - Arrendamentos\n' : '') +
            (auth.hasPermission('monitorabahia.pesquisa_requerimentos') ? ' - Requerimentos' : '')).trimEnd()
        labels[MENU_ITEMS.Aprovar] = ((auth.hasPermission('monitorabahia.aprovacao_pessoas') ? ' - Pessoas\n' : '') +
            (auth.hasPermission('monitorabahia.aprovacao_propriedades') ? ' - Propriedades\n' : '') +
            (auth.hasPermission('monitorabahia.aprovacao_requerimentos') ? ' - Requerimentos de Plantio\n' : '') +
            (auth.hasPermission('monitorabahia.aprovacao_planos') ? ' - Planos de Trabalho\n' : '') +
            (auth.hasPermission('monitorabahia.aprovacao_arrendametos') ? ' - Arrendamentos' : '')).trimEnd()
        labels[MENU_ITEMS.Relatorio] = ((auth.hasPermission('monitorabahia.relatorio_cad_proprietarios') ? ' - Proprietários\n' : '') +
            (auth.hasPermission('monitorabahia.relatorio_cad_propriedades') ? ' - Propriedades\n' : '') +
            (auth.hasPermission('monitorabahia.relatorio_cad_lotes') ? ' - Lotes\n' : '') +
            (auth.hasPermission('monitorabahia.relatorio_pol_propriedades') ? ' - Polígonos de Propriedade\n' : '') +
            (auth.hasPermission('monitorabahia.relatorio_pol_lotes') ? ' - Polígonos de Lotes\n' : '') +
            (auth.hasPermission('monitorabahia.relatorio_pla_usuarios') ? ' - Usuários' : '')).trimEnd()
        labels[MENU_ITEMS.Cadastro] = ((auth.hasPermission('monitorabahia.cadastrar_pessoa') ? ' - Pessoa\n' : '') +
            (auth.hasPermission('monitorabahia.cadastrar_imovel') ? ' - Imóvel\n' : '') +
            (auth.hasPermission('monitorabahia.cadastrar_plantio') ? ' - Plantio\n' : '') +
            (auth.hasPermission('monitorabahia.cadastrar_controles') ? ' - Controles\n' : '') +
            (auth.hasPermission('monitorabahia.cadastrar_arrendamentos') ? ' - Arrendamentos' : '')).trimEnd()
        setMenuLabels(labels)
    }
    const filter = (list: Array<any>, field: any, value: any) => {
        return list.filter((v) => v[field] === value)
    }
    const carregarPessoas = async () => {
        if (auth.hasPermission('monitorabahia.pessoas_view_all')) {
            setPessoas(await API.getPessoas(navigate, error));
        } else {
            setPessoas(auth.user ? [auth.user.pessoa] : []);
        }
    }
    const carregarPropriedades = async () => {
        if (auth.hasPermission('monitorabahia.propriedades_view_all')) {
            const properties = await API.getPropriedades(navigate, (r: any) => console.error(r))
            setPropriedades(properties)
        } else {
            setPropriedades(auth.user?.propriedades ? auth.user?.propriedades : [])
            //console.log('Proriedades do usuario', auth.user, auth.user?.propriedades)
        }
    }
    const carregarPropriedadesSearch = async () => {
        if (auth.hasPermission('monitorabahia.propriedades_view_all')) {
            const props = await API.getPropriedadesSearch(navigate, (r: any) => console.error(r))
            setPropriedadesSearch(props)
        } else {
            if (!auth.user) return console.error('auth.user indefinido')
            if (!auth.user.propriedades) return console.error('auth.user.propriedades indefinido')
            const propsUser:PropriedadeSearchType[] = auth.user.propriedades.map((imovel)=>{
                return {
                    id: imovel.id,
                    nome: imovel.nome,
                    municipio: imovel.municipio,
                    status: imovel.status,
                    doc_matricula: imovel.doc_matricula,
                    proprietario_nome: imovel.proprietario.pessoa.nome_razao
                }
            })
            setPropriedadesSearch(propsUser)
            //console.log('Proriedades do usuario', auth.user, auth.user?.propriedades)
        }
    }
    const carregarPlanos = async () => {
        if (auth.hasPermission('monitorabahia.planos_view_all')) {
            setPlanos(await API.getPlanos(navigate, (r: any) => console.error(r)))
        } else {
            setPlanos(auth.user ? [auth.user.planos] : []);
        }
    }
    const carregarArrendamentos = async () => {
        setArrendamentos(await API.getArrendamentos())
    }
    const carregarGrupos = async () => {
        const grps = await API.getGrupos()
        setGrupos(grps)
    }
    const carregarPermissions = async () => {
        const perms = await API.getAllPerms()
        setPermissions(perms)
    }
    const carregarSafras = async () => {
        const safras = await API.getSafras()
        setSafras(safras)
    }
    const refresh = () => {
        carregarPessoas()
        carregarPropriedades()
        carregarPlanos()
        carregarArrendamentos()
        carregarPermissions()
        carregarSafras()
    }
    const init = async () => {
        if (auth.user === undefined || auth.user instanceof Promise) {
            Auth.signout(() => navigate('/'))
        } else if (auth.user === null) {
            navigate('/')
        } else {
            try {
                const municipios = (await API.getIbgeData(global.uf))
                setMunicipios(municipios)
                //Atualizar municipios
                if (mapRef.current !== null) {
                    const mapa: L.Map = mapas.createMap(mapRef, mapas.mapas.googleHybrid(), municipios);
                    mapa.on('move', () => {
                        const center = mapa.getCenter();
                        setLat(center.lat);
                        setLon(center.lng);
                    });
                    const isProdutorRural = auth.user?.groups.some((group: GroupType) => group.name === 'Produtor Rural');
                    if (isProdutorRural) {
                        const propriedades = await API.getPropriedades(navigate, (r: any) => console.error(r));
                        const propriedadesFiltradas = propriedades.filter((p: any) => p.proprietario.id === auth.user?.id);
                        mapas.loadPropriedades(mapa, propriedadesFiltradas, true);
                        const mun: Array<any> = []
                        propriedadesFiltradas.forEach((p: any) => {
                            mun.push(p.municipio)
                            mapas.loadLotes(mapa, p.lotes);
                        })
                        //Carregar os municípios filtrados
                        if (municipios && municipios.length > 0)
                            new Set(mun).forEach((m: any) => {
                                municipios.filter((data: any) =>
                                    data.id === m
                                ).forEach((data: any) => {
                                    mapas.loadMunicipio(mapa, data, mapas.estiloContorno);
                                })
                            });
                    }
                    // mapas.sideBySide(mapa, mapas.mapas.googleHybrid(), mapas.mapas.arcgis())
                }
            } catch (e: any) {
                messages.message(toastBC.current, 'Erro no carregamento do mapa:' + e)
            }
            refresh()
        }
        updateMenuLabels()
    }

    useEffect(() => {
        init()
        if (!auth.user) return
        carregarGrupos()
    }, [])

    const [showFrameAplicativos, setShowFrameAplicativos] = useState(false)
    const [showFrameCadastrar, setShowFrameCadastrar] = useState(false)
    const [showDialogCadastroPessoa, setShowDialogCadastroPessoa] = useState(false)

    const PesquisarItemMenu = {
        label: 'Pesquisar: \n\n' + menuLabels[MENU_ITEMS.Pesquisa],
        icon: () => <ListIcon />, command: () => { setVisibleDialogSearch(true) }
    }
    const AplicativosItemMenu = {
        label: 'Aplicativos:\n\n - Linha do Tempo de Cobertura Vegetal\n - Análise NDVI e NDWI de Terras Agrícolas',
        icon: () => <AppsIcon />, command: () => { setShowFrameAplicativos(true) }
    }
    const AprovarItemMenu = {
        label: 'Aprovar:\n\n' + menuLabels[MENU_ITEMS.Aprovar],
        icon: () => <AprovarIcon />, command: () => { setVisibleDialogAprovacao(true) }
    }
    const ReportItemMenu = {
        label: 'Relatório:\n\n' + menuLabels[MENU_ITEMS.Relatorio],
        icon: () => <ReportIcon />, command: () => { setVisibleDialogReport(true) }
    }
    const CadastrarItemMenu = {
        label: 'Cadastro:\n\n' + menuLabels[MENU_ITEMS.Cadastro],
        icon: () => <EditIcon />, command: () => { setShowFrameCadastrar(true) }
    }
    const SairItemMenu = { label: 'Sair', icon: () => <OutIcon />, command: () => { Auth.signout(() => navigate('/')) } }

    const items: MenuItem[] = []
    auth.hasPermission(MENU_PERMISSOES.Pesquisa) && items.push(PesquisarItemMenu)
    auth.hasPermission(MENU_PERMISSOES.Aplicativos) && items.push(AplicativosItemMenu)
    auth.hasPermission(MENU_PERMISSOES.Aprovar) && items.push(AprovarItemMenu)
    auth.hasPermission(MENU_PERMISSOES.Relatorio) && items.push(ReportItemMenu)
    auth.hasPermission(MENU_PERMISSOES.Cadastro) && items.push(CadastrarItemMenu)
    items.push(SairItemMenu)

    const openMunicipio = (municipio: any) => (navigate('/municipio', { state: [municipios.filter((m: any) => m.id === municipio.id || m.id === municipio)[0]] }))
    const openPropriedade = (propriedade: PropriedadeSearchType) => (navigate('/propriedade', { state: [propriedade, municipios.filter((m: any) => m.id === propriedade.municipio)[0]] }))
    const [editPessoa, setEditPessoa] = useState(true)
    const openPessoa = (pessoa: PessoaType, edit: boolean) => {
        // console.log('Open pessoa:', pessoa)
        setPessoa(pessoa)
        setActiveIndex(0)
        setShowDialogCadastroPessoa(true)
        setEditPessoa(edit)
    }
    const cadastrarNovaPessoa = () => {
        openPessoa(newPessoa(), true)
    }

    const [visibleDialogSearch, setVisibleDialogSearch] = useState(false)
    const [visibleDialogReport, setVisibleDialogReport] = useState(false)
    const [visibleDialogAprovacao, setVisibleDialogAprovacao] = useState(false)
    const [imovel, setImovel] = useState<ImovelType>(newImovel())
    const [visibleCadastroImovel, setVisibleCadastroImovel] = useState(false)
    const [editableCadastroImovel, setEditableCadastroImovel] = useState(true)
    const [visibleCadastroPlantios, setVisibleCadastroPlantios] = useState(false)
    const [visibleCadastroControles, setVisibleCadastroControles] = useState(false)
    const [visibleCadastroArrendamento, setVisibleCadastroArrendamento] = useState(false)
    const [showDialogResponsavelTecnico, setShowDialogResponsavelTecnico] = useState(false)
    const [showDialogAntecipacoes, setShowDialogAntecipacoes] = useState(false)

    useEffect(() => {
        if (!auth.user) return
        carregarPessoas()
        carregarPlanos()
        carregarArrendamentos()
    }, [visibleDialogSearch, visibleDialogAprovacao, visibleCadastroImovel, visibleCadastroPlantios, visibleCadastroControles, visibleCadastroArrendamento]);
    useEffect(()=>{
        if (!auth.user) return
        if (!visibleDialogSearch){
            setAbaSearch(undefined)
            setNomePropriedadeSearchFilter(undefined)
        }
        if (!(visibleDialogSearch || visibleDialogAprovacao)) return
        carregarPropriedadesSearch()
    }, [visibleDialogSearch, visibleDialogAprovacao])

    const toast = useRef<Toast>(null);
    const handleDownloadClick = async (report: Promise<any>) => {
        setLoadingReport(true)
        // Supondo que toastBC.current seja a referência para o seu componente de Toast
        // Se toastBC não for um ref, ajuste como você passa a referência do toast
        const currentToastRef = toast.current; // Ou qualquer que seja sua referência ao toast

        if (!currentToastRef) {
            console.error("Toast reference is not available.");
            // Adicione um feedback ao usuário aqui, se necessário
            return;
        }

        try {
            currentToastRef.show({ severity: 'info', summary: 'Info', detail: 'Gerando relatório...', life: 3000 });
            const response = await report; // Chama a função e espera pela resposta
            API.downloadFile(response, currentToastRef); // Passa a resposta real para downloadFile
        } catch (error) {
            console.error('Erro ao baixar o arquivo:', error);
            // Tenta extrair uma mensagem de erro mais amigável se for um erro do Axios
            let errorMessage = 'Falha ao gerar ou baixar o relatório.';
            if (axios.isAxiosError(error) && error.response) {
                // Tenta ler o erro como texto, pois pode não ser JSON se for um erro de servidor inesperado
                // ou se o backend retornar um erro como texto/html
                if (error.response.data instanceof Blob && error.response.data.type === "application/json") {
                    try {
                        const errorJson = JSON.parse(await error.response.data.text());
                        errorMessage = errorJson.detail || errorJson.message || errorMessage;
                    } catch (e) {
                        // Não conseguiu parsear como JSON, mantém a mensagem genérica
                    }
                } else if (typeof error.response.data === 'string') {
                    errorMessage = error.response.data;
                }
            }

            currentToastRef.show({
                severity: 'error',
                summary: 'Erro',
                detail: errorMessage,
                life: 5000
            });
        } finally {
            setLoadingReport(false)
        }

    };
    const [isLoadingReport, setLoadingReport] = useState<boolean>(false);
    const abrirSearchPropriedade = (nome: string)=>{
        setAbaSearch(2)
        setVisibleDialogSearch(true)
        setNomePropriedadeSearchFilter(nome)
    }
    (window as any).abrirSearchPropriedade = abrirSearchPropriedade // APENAS PARA TESTES
    return (
        <div className='landing'>
            <CustomToolbar user={auth.user} titulo={'E-DEFESA FITOSSANITÁRIA ADAB'} loading={loading} />

            <DialogSearch visible={visibleDialogSearch} setVisible={setVisibleDialogSearch}
                municipios={municipios} pessoas={pessoas} cultivos={[]} openMunicipio={openMunicipio}
                openPessoa={openPessoa} propriedades={propriedadesSearch||[]} carregarPropriedades={carregarPropriedades}
                openPropriedade={openPropriedade} openCultivo={() => console.log('')} planos={planos} carregarPlanos={carregarPlanos}
                arrendamentos={arrendamentos} carregarArrendamentos={carregarArrendamentos} abrirNaAba={abaSearch}
                nomePropriedadeFilter={nomePropriedadeSearchFilter} />
            <Aplicativos visible={showFrameAplicativos} setVisible={setShowFrameAplicativos} />
            <DialogAprovacao hide={() => setVisibleDialogAprovacao(false)} open={openPessoa} pessoas={filter(pessoas, 'status', STATUS.NOVO)}
                municipios={municipios} show={visibleDialogAprovacao} refresh={refresh} propriedades={filter(propriedades||[], 'status', STATUS.NOVO)}
                openPropriedade={openPropriedade} planos={planos} carregarPlanos={carregarPlanos} arrendamentos={arrendamentos} rts={filter(pessoas, 'status_rt', STATUS.NOVO)} />

            <CadastroPessoa function={setShowDialogCadastroPessoa} state={showDialogCadastroPessoa} pessoas={pessoas} pessoa={pessoa} setPessoa={setPessoa} activeIndex={activeIndex} setActiveIndex={setActiveIndex} edit={editPessoa} />
            <CadastroImovel visible={visibleCadastroImovel} setVisible={setVisibleCadastroImovel} pessoas={pessoas} municipios={municipios} imovel={imovel} setImovel={setImovel} edit={editableCadastroImovel} abrirSearchPropriedade={abrirSearchPropriedade}/>
            <CadastroPlantio propriedades={propriedades||[]} visible={visibleCadastroPlantios} setVisible={setVisibleCadastroPlantios} config={CadastroPlantioConfig.CADASTRO_PRODUTOR} plano={null} />
            <CadastroControles propriedades={propriedades||[]} visible={visibleCadastroControles} setVisible={setVisibleCadastroControles} />
            <CadastroArrendamento propriedades={propriedades||[]} visible={visibleCadastroArrendamento} setVisible={setVisibleCadastroArrendamento} />
            <ResponsavelTecnico visible={showDialogResponsavelTecnico} setVisible={setShowDialogResponsavelTecnico} pessoas={pessoas} onSuccess={carregarPessoas} />
            <DialogAntecipacoes show={showDialogAntecipacoes} hide={() => setShowDialogAntecipacoes(false)} planos={planos} propriedades={propriedades||[]} safras={safras} carregarPlanos={carregarPlanos} />

            <Dialog header={<div style={{ display: 'flex', alignItems: 'center' }}><ReportIcon style={{ marginRight: 5 }} width={32} />RELATÓRIOS</div>} visible={visibleDialogReport} onHide={() => setVisibleDialogReport(false)}>
                <BlockUI blocked={isLoadingReport} template={<ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="transparent" animationDuration=".5s" />}>
                    <TabView>
                        {auth.hasPermission(MENU_PERMISSOES.Relatorio_Cadastros) && <TabPanel header="Cadastros" leftIcon={<HiDocumentReport />}>
                            <div className="m-0">
                                <Toast ref={toast} />
                                {auth.hasPermission('monitorabahia.relatorio_cad_proprietarios') && <p><Button style={{ width: '100%' }} size="large" onClick={() => handleDownloadClick(API.report('report/owners'))}><GiFarmer style={{ marginRight: 5 }} />Proprietários</Button></p>}
                                {auth.hasPermission('monitorabahia.relatorio_cad_propriedades') && <p><Button style={{ width: '100%' }} size="large" onClick={() => handleDownloadClick(API.report('report/properties'))}><MdAgriculture style={{ marginRight: 5 }} />Propriedades</Button></p>}
                                {auth.hasPermission('monitorabahia.relatorio_cad_lotes') && <p><Button style={{ width: '100%' }} size="large" onClick={() => handleDownloadClick(API.report('report/lots'))}><FaMapMarkedAlt style={{ marginRight: 5 }} />Lotes</Button></p>}
                            </div>
                        </TabPanel>}
                        {auth.hasPermission(MENU_PERMISSOES.Relatorio_Poligonos) && <TabPanel header="Poligonos" leftIcon={<HiDocumentReport />}>
                            <div className="m-0">
                                <Toast ref={toast} />
                                {auth.hasPermission('monitorabahia.relatorio_pol_propriedades') && <p><Button style={{ width: '100%' }} size="large" onClick={() => handleDownloadClick(API.report('report/property-summary'))}><MdAgriculture style={{ marginRight: 5 }} />Propriedades</Button></p>}
                                {auth.hasPermission('monitorabahia.relatorio_pol_lotes') && <p><Button style={{ width: '100%' }} size="large" onClick={() => handleDownloadClick(API.report('report/lotes-detalhado'))}><FaMapMarkedAlt style={{ marginRight: 5 }} />Lotes</Button></p>}
                            </div>
                        </TabPanel>}
                        {auth.hasPermission(MENU_PERMISSOES.Relatorio_Plataforma) && <TabPanel header="Plataforma" leftIcon={<HiDocumentReport />}>
                            <div className="m-0">
                                <Toast ref={toast} />
                                <p><Button style={{ width: '100%' }} size="large" onClick={() => handleDownloadClick(API.report('report/users'))}><GiFarmer style={{ marginRight: 5 }} />Usuários</Button></p>
                            </div>
                        </TabPanel>}
                    </TabView>
                    <Messages ref={msgs} style={{ position: 'fixed', bottom: 20, right: 20 }} />
                </BlockUI>
            </Dialog>

            <Dialog style={{ maxHeight: '100dvh' }} header={<div style={{ display: 'flex', alignItems: 'center', height: 10 }}><EditIcon style={{ marginRight: 5 }} width={32} />CADASTRAR</div>} visible={showFrameCadastrar} onHide={() => setShowFrameCadastrar(false)} headerStyle={{ paddingBottom: '0px' }}>
                <Toast ref={toastCadastrar} position="center" onRemove={() => toastCadastrar.current && messages.clear(toastCadastrar.current)} />
                <TabView>
                    <TabPanel header="Produtor" leftIcon="pi pi-users mr-2">
                        <div className="m-0">
                            {auth.hasPermission('monitorabahia.cadastrar_pessoa') && <p><Button style={{ width: '100%' }} size="large" onClick={cadastrarNovaPessoa}><GiFarmer style={{ marginRight: 5 }} />Pessoa</Button></p>}
                            {auth.hasPermission('monitorabahia.add_responsavel_tecnico') && <p><Button style={{ width: '100%' }} size="large" onClick={() => setShowDialogResponsavelTecnico(true)}><PiIdentificationBadgeFill style={{ marginRight: 5 }} />Responsável Técnico</Button></p>}
                            {auth.hasPermission('monitorabahia.cadastrar_imovel') && <p><Button style={{ width: '100%' }} size="large" onClick={() => { setImovel(newImovel); setVisibleCadastroImovel(true) }}><PiFarmFill style={{ marginRight: 5 }} />Imovel</Button></p>}
                            {auth.hasPermission('monitorabahia.cadastrar_plantio') && <p><Button style={{ width: '100%' }} size="large" onClick={() => setVisibleCadastroPlantios(true)} ><FaMapMarkedAlt style={{ marginRight: 5 }} />Plantio</Button></p>}
                            {auth.hasPermission('monitorabahia.cadastrar_controles') && <p><Button style={{ width: '100%' }} size="large" onClick={() => setVisibleCadastroControles(true)} ><GiRemedy style={{ marginRight: 5 }} />Controles</Button></p>}
                            {auth.hasPermission('monitorabahia.cadastrar_arrendamentos') && <p><Button style={{ width: '100%' }} size="large" onClick={() => setVisibleCadastroArrendamento(true)} ><FaFileContract style={{ marginRight: 5 }} />Arrendamentos</Button></p>}
                            {(auth.hasPermission('monitorabahia.cadastrar_plantio') || auth.hasPermission('monitorabahia.cadastrar_controles')) && <p><Button style={{ width: '100%' }} size="large" onClick={() => setShowDialogAntecipacoes(true)} severity="success" disabled ><MdAgriculture style={{ marginRight: 5 }} />Antecipação de Plantio da Soja</Button></p>}
                        </div>
                    </TabPanel>
                    {auth.hasPermission('auth.change_permission') &&
                        <TabPanel header="Perfis de Acesso" leftIcon="pi pi-lock mr-2">
                            <TabPermissoes permissions={permissions} groups={grupos} toast={toastCadastrar.current}></TabPermissoes>
                        </TabPanel>
                    }
                    {auth.hasPermission('auth.edit_group_permissions') &&
                        <TabPanel header="Perfil de Usuário" leftIcon="pi pi-user mr-2">
                            <TabUsuarioPermissoes pessoas={pessoas} grupos={grupos} pessoa={pessoa} setPessoa={setPessoa} error={error} />
                        </TabPanel>
                    }
                    {auth.hasPermission('auth.change_permission') &&
                        <>
                            <TabPanel header="Eventos" leftIcon="pi pi-calendar mr-2">
                                <p className="m-0">
                                    <p><Button style={{ width: '100%' }} size="large" onClick={() => navigate('/cadastroVazio')} icon={<MdMap />}>Monitoramento</Button></p>
                                    <p><Button style={{ width: '100%' }} size="large" onClick={() => messages.littleMessage(msgs.current)} icon='pi pi-calendar'>Antecipação</Button></p>
                                </p>
                            </TabPanel>
                            <TabPanel header="Organização" leftIcon="pi pi-building mr-2">
                                <p className="m-0">
                                    <p><Button style={{ width: '100%' }} size="large" onClick={() => messages.littleMessage(msgs.current)} icon='pi pi-th-large'>Culturas</Button></p>
                                </p>
                            </TabPanel>
                        </>
                    }
                </TabView>
                <Messages ref={msgs} style={{ position: 'fixed', bottom: 20, right: 20 }} />
            </Dialog>
            <div id='map' ref={mapRef} />
            {auth.hasPermission('monitorabahia.pesquisa_propriedades') && <PropertySummaryWidget propriedades={propriedades} navigate={navigate}/>}
            <WeatherForecastWidget lat={lat} lon={lon} />

            <Toast ref={toastBC} position="center" onRemove={() => toastBC.current && messages.clear(toastBC.current)} />

            <Tooltip className="dark-tooltip" target=".dock-window .p-dock-action" my="center bottom-15" at="center top" showDelay={150} />
            <div className="dock-window">
                <Dock model={items} position={'bottom'} />
            </div>
        </div>
    );
}

export default Home;